import { render } from "./BtnPracticeStart.vue?vue&type=template&id=41b4b96f&scoped=true"
import script from "./BtnPracticeStart.vue?vue&type=script&lang=js"
export * from "./BtnPracticeStart.vue?vue&type=script&lang=js"

import "@/css/components/btn-practice-start.css?vue&type=style&index=0&id=41b4b96f&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41b4b96f"]])

export default __exports__